import { createReducer } from "@reduxjs/toolkit";

import {
  getSuggestedLivestreamsFailure,
  getSuggestedLivestreamsSuccess,
  getSuggestedLivestreams,
  getSuggestedLivestreamsPortion,
  getSuggestedLivestreamsPortionSuccess,
  getSuggestedLivestreamsPortionFailure,
} from "./actions";

/**
 * @property {number[]} allSubscriptions array of subscription ids
 * @property {object[]} subscriptionById { [subscriptionId]: {subscriptionContent} }
 */
const initialState = {
  data: [],
  nextOffset: undefined,
  totalCount: undefined,
  isLoading: false,
  error: null,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(getSuggestedLivestreams.type, (state) => ({
      ...state,
      isLoading: true,
      error: null,
    }))
    .addCase(getSuggestedLivestreamsSuccess.type, (state, { payload }) => ({
      ...state,
      isLoading: false,
      data: payload.data,
      ...payload,
    }))
    .addCase(getSuggestedLivestreamsFailure.type, (state) => ({
      ...state,
      isLoading: false,
    }))
    .addCase(getSuggestedLivestreamsPortion.type, (state) => ({
      ...state,
      isLoading: true,
      error: null,
    }))
    .addCase(
      getSuggestedLivestreamsPortionSuccess.type,
      (state, { payload }) => ({
        ...state,
        isLoading: false,
        totalCount: payload.totalCount,
        nextOffset: payload.nextOffset,
        data: [...state.data, ...payload.data],
      }),
    )
    .addCase(getSuggestedLivestreamsPortionFailure.type, (state) => ({
      ...state,
      isLoading: false,
    }));
});
